
<template>
    <v-dialog
            v-if="getModalType !== 'info' && getModalType !== 'map'"
            class="modal"
            v-model="dialog"
            :persistent="true"
            @keydown.esc="closeHandler">
        <div class="modal__inner">
            <div class="modal__close"></div>
            <div class="modal__content">
                <h4 class="title-h4 ">
                    {{$t(`modal.action.${this.getModalType}.title`)}}
                </h4>
                <!--<div class="modal__subtitle font-reg" v-html="$t(`modal.action.${this.getModalType}.subtitle`)"></div>-->
                <div class="modal__subtitle font-reg" v-html="$t(`modal.action.${this.getModalType}.subtitle`, {userName: this.getModalData.name})">
                    <!--{{ $t(`modal.action.${this.getModalType}.subtitle`, {userName: this.getModalData.name}) }}-->

                </div>
                <div class="modal__action">
                    <button @click.prevent="closeHandler" class="btn btn-cancel">{{ $t("form.cancel") }}</button>
                    <button @click.prevent="fireApi"      class="btn btn-gradient btn-h40">
                        <span>{{ $t("form.yes") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
    import actions from '@/mixins/actions'
    export default {
        mixins: [actions],
        methods: {
            fireApi() {
                switch(this.getModalType) {
                    case('Extend'):
                        this.extendHandler(this.getModalData.expired_id);
                        break;
                    case("Delete"):
                        this.deleteHandler(this.getModalData.id);
                        break;
                    case("Approve"):
                        this.approveHandler(this.getModalData.id);
                        break;
                    case("Decline"):
                        this.declineHandler(this.getModalData.id);
                        break;
                }
//                this.closeHandler();
            }

        },

    }
</script>

<style lang="sass" scoped="">
    .modal
        &__inner
            padding: 40px
            background-color: $color--white
            text-align: center
            +rmin(767)
                max-width: 470px
                margin: 0 auto
            +sm
                padding: 24px 16px
        &__subtitle
            margin: 16px 0 32px 0
            font-size: 16px
        &__action
            display: flex
            justify-content: center
            align-items: center
            .btn + .btn
                margin-left: 48px
    .btn-gradient
        min-width: 140px
    .v-dialog__content
        +r(767)
            align-items: flex-end
</style>

